export default __webpack_public_path__ + "static/media/cover.7ae10a38.jpeg";